import { render } from "./quote-list.vue?vue&type=template&id=a2a8be1e&scoped=true&ts=true"
import script from "./quote-list.vue?vue&type=script&lang=ts"
export * from "./quote-list.vue?vue&type=script&lang=ts"

import "./quote-list.vue?vue&type=style&index=0&id=a2a8be1e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2a8be1e"]])

export default __exports__